import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { MobileHeader } from "./MobileHeader";
import { QuoteCard } from "./QuoteCard";
import { NewQuoteSheet } from "./NewQuoteSheet";
import { Input } from "../components/ui/input";
import { MagnifyingGlass, Plus, ReceiptX } from "@phosphor-icons/react";

export default function MobileQuotesList() {
  const { t } = useTranslation();
  const { carts, loaded } = useCart();
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [newQuoteOpen, setNewQuoteOpen] = useState(false);

  const filtered = useMemo(() => {
    const list = [...carts].reverse();
    if (!query.trim()) return list;
    const q = query.toLowerCase();
    return list.filter((c) => c.name.toLowerCase().includes(q) || (c.customer_name || "").toLowerCase().includes(q));
  }, [carts, query]);

  return (
    <div data-testid="mobile-quotes-list-screen">
      <MobileHeader title={t("mobile.quotes")} subtitle={t("mobile.total", { count: carts.length })} />

      <div className="px-4 pt-3 pb-1">
        <div className="relative">
          <MagnifyingGlass size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#78716C]" />
          <Input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder=""
            data-testid="mobile-quotes-search-input"
            className="h-11 pl-11 rounded-[12px] border-[#E7E5E4] bg-white text-base"
          />
        </div>
      </div>

      <div className="px-4 pt-3">
        {loaded && filtered.length === 0 && (
          <div className="text-center py-16 rounded-[16px] border border-dashed border-[#E7E5E4]" data-testid="mobile-quotes-empty-state">
            <ReceiptX size={32} weight="duotone" className="text-[#78716C] mx-auto mb-2" />
            <p className="text-sm text-[#78716C]">
              {query ? t("mobile.no_quotes_match") : t("mobile.no_quotes")}
            </p>
          </div>
        )}
        {filtered.length > 0 && (
          <div className="bg-white rounded-[14px] border border-[#E7E5E4] overflow-hidden" data-testid="mobile-quotes-list">
            {filtered.map((cart) => (
              <QuoteCard key={cart.id} cart={cart} onClick={() => navigate(`/m/quotes/${cart.id}`)} />
            ))}
          </div>
        )}
      </div>

      <button
        onClick={() => setNewQuoteOpen(true)}
        aria-label="New Quotation"
        data-testid="mobile-quotes-fab-new"
        className="press-scale fixed bottom-24 right-5 w-14 h-14 rounded-full bg-[#1E3A8A] text-white flex items-center justify-center shadow-[0_10px_24px_-6px_rgba(30,58,138,0.55)] transition-colors duration-200 z-30"
      >
        <Plus size={24} weight="bold" />
      </button>

      <NewQuoteSheet open={newQuoteOpen} onOpenChange={setNewQuoteOpen} />
    </div>
  );
}
